import { API_BASE } from "../utils/baseapiurl";

class BoBDocumentsAPI {
	async request(path, { method = "GET", body, json = true } = {}) {
		const response = await fetch(`${API_BASE}${path}`, {
			method,
			headers: {
				// FormData bodies must set their own multipart boundary, so no Content-Type for them.
				...(json ? { "Content-Type": "application/json" } : {}),
				"X-WP-Nonce": window.wpApiSettings?.nonce || "",
			},
			credentials: "include",
			...(body ? { body: json ? JSON.stringify(body) : body } : {}),
		});

		const data = await response.json().catch(() => ({}));

		if (!response.ok) {
			throw new Error(data.message || (response.status === 413 ? "This file is too large." : "Something went wrong. Please try again."));
		}

		return data;
	}

	/** Documents for one live BoB row, newest first. */
	getDocuments(clientKey) {
		return this.request(`/agent-bob/documents?${new URLSearchParams({ anchor_key: clientKey })}`);
	}

	/**
	 * One file per request, so each succeeds or fails on its own. `period` is the cutoff
	 * ("YYYY-MM") it is uploaded from; the server checks the client is in it.
	 */
	upload(clientKey, file, period = null) {
		const fd = new FormData();
		fd.append("anchor_key", clientKey);
		if (period) fd.append("period", period);
		fd.append("file", file, file.name);

		return this.request("/agent-bob/documents/upload", { method: "POST", body: fd, json: false });
	}

	deleteDocument(id) {
		return this.request("/agent-bob/documents/delete", { method: "POST", body: { id } });
	}

	/**
	 * A plain link: the server checks access, then redirects to a short-lived S3 link. The nonce
	 * rides in the query because a navigation can't send the X-WP-Nonce header.
	 */
	downloadUrl(id) {
		return `${API_BASE}/agent-bob/documents/download?${new URLSearchParams({ id, _wpnonce: window.wpApiSettings?.nonce || "" })}`;
	}
}

export default new BoBDocumentsAPI();
